<div *ngIf="patient" class="d-flex">
  <div class="mr-auto">
    <h3 style="margin-bottom: -5px;" class="mr-auto">{{patient.name}}</h3>
    <span><strong><small><em>Nasc: {{patient.dob | date:'dd/LL/yyyy'}}</em></small></strong></span>
    <span class="mr-3"><strong><small><em> ({{getPatientAge()}})</em></small></strong></span>
    <span *ngIf="patient.mother_name" class="mr-3"><strong><small><em>Mãe: {{patient.mother_name}}</em></small></strong></span>
    <span *ngIf="patient.father_name"><strong><small><em>Pai: {{patient.father_name}}</em></small></strong></span>
  </div>
</div>
<div class="d-flex mb-3 mt-0 pt-0">
  <div *ngIf="showPhones" class="mr-3">
    <strong><small>
        <span *ngIf="patient.homephone"><b>Res:</b> {{patient.homephone}}</span>
        <span *ngIf="patient.homephone && patient.cellphone"> / </span>
        <span *ngIf="patient.cellphone" class="mr-1"><b>Cel:</b> {{patient.cellphone}}</span>
    </small></strong>
  </div>
  <div *ngIf="schedulingTypeName" class="mr-auto">
    <strong><small>
        <span *ngIf="schedulingTypeName" class="mr-3"><b>Pagamento:</b> {{schedulingTypeName}}</span>
        <span *ngIf="appointmentTypeName"><b>Tipo:</b> {{appointmentTypeName}}</span>
    </small></strong>
  </div>
</div>
